import { CzMaxPrice, ProductUpdate, ValidationResult } from '~/Api/User/ProductGroup/CzMaxPrice';

export enum ActionType {
	request = 'CzMaxPrice.request',
	receive = 'CzMaxPrice.receive',
	requestUpdate = 'CzMaxPrice.requestUpdate',
	receiveUpdate = 'CzMaxPrice.receiveUpdate',
	scheduleUpdate = 'CzMaxPrice.scheduleUpdate',
	requestXlsCreate = 'CzMaxPrice.requestXlsCreate',
	receiveXlsCreate = 'CzMaxPrice.receiveXlsCreate',
	prune = 'CzMaxPrice.prune',
}

export interface RequestAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.request;
}

export interface ReceiveAction {
	groupId: string;
	czMaxPrice: CzMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receive;
}

export interface ScheduleUpdateAction {
	basketVersion: string;
	groupId: string;
	packageSize: number | null;
	products: ProductUpdate[];
	timeoutId: NodeJS.Timeout;
	type: ActionType.scheduleUpdate;
}

export interface RequestUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestUpdate;
}

export interface ReceiveUpdateAction {
	groupId: string;
	czMaxPrice: CzMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receiveUpdate;
}

export interface RequestXlsCreateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestXlsCreate;
}

export interface ReceiveXlsCreateAction {
	request: Promise<any>;
	type: ActionType.receiveXlsCreate;
	validationResult: ValidationResult | null;
}

export interface PruneAction {
	groupId: string;
	type: ActionType.prune;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| ScheduleUpdateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| RequestXlsCreateAction
	| ReceiveXlsCreateAction
	| PruneAction;
